import { useQuery } from '@tanstack/react-query';
import type { MaintenanceCyclePhasesResponse } from '../../../recommendations/types';
import { useForBindingId } from '../../../forBinding';
import api from '../../http';
import { toApiError } from '../utils';

export function useGetDynamicCyclePhases(
	parcellingId: string,
	floweringDate: string,
	enabled: boolean
) {
	const forBinding = useForBindingId();

	return useQuery({
		queryKey: ['maintenance', 'cycle-phases', forBinding, parcellingId, floweringDate],
		enabled: enabled && !!parcellingId && !!floweringDate,
		retry: false,
		queryFn: async () => {
			try {
				const { data } = await api.get<MaintenanceCyclePhasesResponse>(
					'/advices/fertilization-plan/cycle-phases',
					{ params: { forBinding, parcellingId, floweringDate } }
				);
				return data;
			} catch (error) {
				throw toApiError(error, 'Erro ao calcular as fases do ciclo');
			}
		},
	});
}
